// react, redux-form
import React, { Component } from "react";
import { Field } from "redux-form";

// helpers
import { required, email, numberLimit, phoneNumber, oneContactNumberRequired } from "../../helpers/validate";

// enums
import { TITLE_LIST } from "../../config/enums";

// render components
import RenderField from "./RenderField";

class Profile extends Component {
  render() {

    const { formData, section } = this.props;
    
    // Remove phone number note if one is field out

    let contactNote = '(At least one phone number is required)';

    if (formData[section] && !formData[section].telephone && !formData[section].mobile) {
      contactNote = '(At least one phone number is required)';
    } else {
      contactNote = '';
    }

    return (
      <div className="sq-form-section">
        <Field
          name="title"
          type="select"
          component={RenderField}
          templateList={TITLE_LIST}
          label="Title"
          width="fourth"
          validate={required}
          required
        />
        <Field
          name="givenName"
          type="text"
          component={RenderField}
          label="First name"
          width="third"
          validate={required}
          required
        />
        <Field
          name="familyName"
          type="text"
          component={RenderField}
          label="Surname"
          width="third"
          validate={required}
          required
        />
        <Field
          name="organisationName"
          type="text"
          component={RenderField}
          label="Business or organisation name"
        />
        <Field
          name="abn"
          type="text"
          component={RenderField}
          label="ABN"
          width="half"
          validate={numberLimit}
        />
        <Field
          name="positionTitle"
          type="text"
          component={RenderField}
          label="Position title"
          width="half"
        />
        <Field
          name="email"
          type="text"
          component={RenderField}
          label="Email"
          validate={[required, email]}
          required
        />
        <Field
          name="telephone"
          type="text"
          component={RenderField}
          label="Telephone"
          note={contactNote}
          width="half"
          required={!formData[section].telephone && !formData[section].mobile ? 'Required' : null}
          validate={[phoneNumber, oneContactNumberRequired]}
        />
        <Field
          name="mobile"
          type="text"
          component={RenderField}
          label="Mobile"
          note={contactNote}
          width="half"
          required={!formData[section].telephone && !formData[section].mobile ? 'Required' : null}
          validate={[phoneNumber, oneContactNumberRequired]}
        />
      </div>
    );
  }
}

export default Profile;
